/**
 * Pantalla de enrolamiento OBLIGATORIO de la verificación en 2 pasos.
 *
 * El Router la renderiza cuando auth.type === AUTH.MFA_ENROLL_REQUIRED:
 * el administrador marcó `mfa.required` para el usuario y este aún no tiene
 * ningún método registrado. No hay forma de saltarla — la única salida es
 * cerrar sesión. (Además las Security Rules bloquean Firestore para un
 * usuario `required` sin método, así que el gate no es solo visual.)
 *
 * El usuario elige el método:
 *  - App de autenticación (TOTP, recomendado) → enroll/totp.js
 *  - Código por correo → enroll/email.js
 */

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Card, Button, Typography } from 'antd';
import { MobileOutlined, MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';

import { logout } from '../../../actions/auth/logout';
import { MfaEnrollTotp } from './totp';
import { MfaEnrollEmail } from './email';
import '../../styles/login.scss';

const { Title, Paragraph } = Typography;
const LogoCompany = 'https://firebasestorage.googleapis.com/v0/b/gestor-documental-67434.appspot.com/o/Cabezote_Web_CR.gif?alt=media&token=71d4c061-1cd3-4ed7-b23c-ee25f5c2c916';

export const MfaEnroll = ({ onEnrolled }) => {

  const dispatch = useDispatch();
  const [method, setMethod] = useState(null); // null | 'totp' | 'email'

  return (
    <div className = 'cuerpo cuerpo-mfa' >

      <div className = 'imagenInicio' >
        <img alt = "logo" src = { LogoCompany } />
      </div>
      <div className = 'login login-mfa' >

        <div style = {{ maxWidth: 420, padding: 16 }} >

          <Title level = { 4 } > Active la verificación en 2 pasos </Title>
          <Paragraph>
            El administrador estableció la verificación en 2 pasos como
            obligatoria para su cuenta. Elija cómo quiere recibir el código
            de seguridad al iniciar sesión.
          </Paragraph>

          { method === null &&
            <>
              <Card hoverable style = {{ marginBottom: 12 }} onClick = { () => setMethod('email') } >
                <Card.Meta
                  avatar = { <MailOutlined style = {{ fontSize: 24 }} /> }
                  title = "Código por correo (recomendado)"
                  description = "Recibirá un código de 6 dígitos en su correo registrado cada vez que inicie sesión" />
              </Card>
              <Card hoverable style = {{ marginBottom: 12 }} onClick = { () => setMethod('totp') } >
                <Card.Meta
                  avatar = { <MobileOutlined style = {{ fontSize: 24 }} /> }
                  title = "App de autenticación"
                  description = "Códigos generados por Google Authenticator, Microsoft Authenticator u otra app similar" />
              </Card>
            </> }

          { method === 'totp' && <MfaEnrollTotp onEnrolled = { onEnrolled } /> }
          { method === 'email' && <MfaEnrollEmail onEnrolled = { onEnrolled } /> }

          <div style = {{ marginTop: 16 }} >
            { method !== null &&
              <Button type = "link" icon = { <ArrowLeftOutlined /> } style = {{ padding: 0 }}
                onClick = { () => setMethod(null) } >
                Elegir otro método
              </Button> }
            <Button type = "link" className = "login-form-forgot"
              onClick = { () => dispatch( logout() ) } >
              Cerrar sesión
            </Button>
          </div>

        </div>

      </div>
    </div>
  );
};
